export enum InboundEmailParsedStatusEnum {
  UNKNOWN = "unknown",
  PENDING_PARSE = "pending_parse",
  PENDING_UPLOAD = "pending_upload",
  UPLOADED = "uploaded",
  CANCELLED = "cancelled",
}
